import { AddTicketCommentDocument } from 'generated/resources/graphql'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import { trackAddTicketComment } from 'modules/ticketing/lib/tracking'
import { OneCreateAction, OneCreationActionResolver } from 'modules/core/lib/oneCreateActions/types'

const useCreateTicketCommentActionResolver: OneCreationActionResolver = () => {
  const { company } = useCurrentSession()

  const [addTicketComment, { loading }] = useMutation(AddTicketCommentDocument, {
    extractorFn: (data) => data.ticketingMutations.createTicketingTicketComment,
    errorPolicy: 'all',
  })

  const createTicketCommentHandler = async (args: { ticketId: string; body: string }) => {
    const result = await addTicketComment({
      variables: {
        companyId: company.id,
        ticketId: args.ticketId,
        body: args.body,
      },
    })

    const handled = handleResult(result, (_errors) => {})

    if (handled.success) {
      trackAddTicketComment({ origin: 'one', has_ai_enhancement: false })
      return { success: true as const, data: args }
    }

    return handled
  }

  return {
    resolver: createTicketCommentHandler,
    loading,
  }
}

export const CreateTicketCommentAction: OneCreateAction = {
  actionResolver: useCreateTicketCommentActionResolver,
  policies: ['Ticketing_aiFeatures'],
}
